import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "automatic-status-update" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row wrap" }, "Equipment events", -1 /* HOISTED */)
const _hoisted_3 = { class: "col" }
const _hoisted_4 = {
  key: 0,
  class: "q-pa-md"
}
const _hoisted_5 = { class: "row justify-left q-mb-md items-end" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "q-ml-sm" }, "Select equipment", -1 /* HOISTED */)
const _hoisted_8 = { class: "col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "q-ml-sm" }, "Select Status", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_HistoricalStatusDialog = _resolveComponent("HistoricalStatusDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageTitle, {
      title: "Automatic Status Update",
      page: _ctx.pageEnum.AutomaticStatus
    }, null, 8 /* PROPS */, ["page"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_card, { class: "q-mb-lg" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row justify-between card-title" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_q_separator),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.getautomaticStatusData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_q_table, {
                    selected: _ctx.selected,
                    "onUpdate:selected": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selected) = $event)),
                    flat: "",
                    bordered: "",
                    "hide-pagination": false,
                    columns: _ctx.columnsautomaticStatus,
                    data: _ctx.filterByEquipStatus(_ctx.getautomaticStatusData),
                    rows: _ctx.filterByEquipStatus(_ctx.getautomaticStatusData),
                    pagination: _ctx.pagination,
                    "selected-rows-label": _ctx.getSelectedString,
                    selection: "multiple"
                  }, {
                    top: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_q_btn, {
                          outline: "",
                          rounded: "",
                          "no-caps": "",
                          disabled: _ctx.selected.length === 0,
                          label: "Confirm Selected Status",
                          class: "q-mx-md main-button",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSelectedBtnClick(_ctx.selected)))
                        }, null, 8 /* PROPS */, ["disabled"]),
                        _createElementVNode("div", _hoisted_6, [
                          _hoisted_7,
                          _createVNode(_component_q_select, {
                            modelValue: _ctx.autoEquipmentFilter,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.autoEquipmentFilter) = $event)),
                            options: _ctx.equipmentSearch,
                            outlined: "",
                            dense: "",
                            "use-input": "",
                            clearable: "",
                            "stack-label": "",
                            "input-debounce": "0",
                            "option-label": 
                      (equipment) =>
                        Object(equipment) === equipment &&
                        'name' in equipment.equipmentModel
                          ? equipment.equipmentModel.name +
                            (equipment.tag ? '-' + equipment.tag : '')
                          : ''
                    ,
                            behavior: "menu",
                            rounded: "",
                            style: {"width":"250px"},
                            class: "q-mx-sm",
                            onFilter: _ctx.filterEquipment
                          }, null, 8 /* PROPS */, ["modelValue", "options", "option-label", "onFilter"])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createVNode(_component_q_select, {
                            modelValue: _ctx.equipmentStatusFilter,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.equipmentStatusFilter) = $event)),
                            options: _ctx.autoStatuses,
                            "option-label": "label",
                            "option-value": "value",
                            outlined: "",
                            dense: "",
                            "use-input": "",
                            clearable: "",
                            "stack-label": "",
                            "input-debounce": "0",
                            behavior: "menu",
                            rounded: "",
                            style: {"width":"250px"},
                            class: "q-mx-sm",
                            "map-options": "",
                            "emit-value": ""
                          }, null, 8 /* PROPS */, ["modelValue", "options"])
                        ]),
                        _createVNode(_component_q_checkbox, {
                          modelValue: _ctx.isChecked,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isChecked) = $event)),
                          label: "Critical only",
                          class: "q-mx-sm",
                          "true-value": true,
                          "false-value": false
                        }, null, 8 /* PROPS */, ["modelValue"]),
                        _createVNode(_component_q_btn, {
                          outline: "",
                          rounded: "",
                          "no-caps": "",
                          disabled: _ctx.selected.length > 0,
                          class: "main-button q-ml-sm",
                          label: "Reset filters",
                          onClick: _ctx.resetFilters
                        }, null, 8 /* PROPS */, ["disabled", "onClick"])
                      ])
                    ]),
                    body: _withCtx((props) => [
                      _createVNode(_component_q_tr, { props: props }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_td, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_checkbox, {
                                modelValue: props.selected,
                                "onUpdate:modelValue": ($event: any) => ((props.selected) = $event)
                              }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */),
                          _createVNode(_component_q_td, {
                            key: "date",
                            "column-sort-order": "da",
                            style: {"width":"15%"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(props.row.date)), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */),
                          _createVNode(_component_q_td, {
                            key: "tagId",
                            style: {"width":"15%"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(props.row.equipment.tagId), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */),
                          _createVNode(_component_q_td, {
                            key: "status",
                            style: {"width":"30%"},
                            class: "automatic-status-text"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: _normalizeClass({
                      green:
                        props.row.status == 'run' ||
                        props.row.status == 'run_limited',
                      grey: props.row.status == 'abnr',
                      orange: props.row.status == 'scheduled',
                      red: props.row.status == 'unscheduled',
                    })
                              }, _toDisplayString(props.row.status), 3 /* TEXT, CLASS */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */),
                          _createVNode(_component_q_td, {
                            key: "automaticStatusAction",
                            style: {"width":"40%"}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_q_btn, {
                                  outline: "",
                                  rounded: "",
                                  "no-caps": "",
                                  disabled: _ctx.selected.length > 0,
                                  label: "Confirm Status",
                                  class: "q-mr-sm main-button",
                                  onClick: ($event: any) => (_ctx.onStatusBtnClick(props.row, 'confirm'))
                                }, null, 8 /* PROPS */, ["disabled", "onClick"]),
                                _createVNode(_component_q_btn, {
                                  outline: "",
                                  rounded: "",
                                  "no-caps": "",
                                  disabled: _ctx.selected.length > 0,
                                  label: "Update Status",
                                  class: "q-mr-sm main-button",
                                  onClick: ($event: any) => (_ctx.onStatusBtnClick(props.row, 'update'))
                                }, null, 8 /* PROPS */, ["disabled", "onClick"]),
                                _createVNode(_component_q_btn, {
                                  outline: "",
                                  rounded: "",
                                  "no-caps": "",
                                  disabled: _ctx.selected.length > 0,
                                  label: "Delete Status",
                                  class: "q-mr-sm main-button",
                                  onClick: ($event: any) => (_ctx.onStatusBtnClick(props.row, 'delete'))
                                }, null, 8 /* PROPS */, ["disabled", "onClick"]),
                                _createVNode(_component_ConfirmDialog, {
                                  title: _ctx.confirmPopUpTitle,
                                  message: _ctx.confirmDeleteMessage,
                                  open: _ctx.displayConfirmDialog,
                                  "data-test": "button-close",
                                  onOnClose: _ctx.onClose,
                                  onOnConfirm: _ctx.onDelete
                                }, null, 8 /* PROPS */, ["title", "message", "open", "onOnClose", "onOnConfirm"])
                              ])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["selected", "columns", "data", "rows", "pagination", "selected-rows-label"])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_HistoricalStatusDialog, {
        status: _ctx.currentSelectedStatus,
        onUpdate_success_emmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateSuccess()))
      }, null, 8 /* PROPS */, ["status"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}